




































































































import { defineComponent, useRoute } from '@nuxtjs/composition-api'
import { CitationResult } from '~/types/product/productTypes'
import IconFaSolidCamera from '~icons/fa-solid/camera'
import { generateReferenceUrl } from '@/common/utils/product/product'
import usePDPAnalytics from '@/composables/analytics/usePDPAnalytics'

export default defineComponent({
  name: 'CitationLine',
  components: {
    IconFaSolidCamera,
  },
  props: {
    citationResult: {
      type: Object as () => CitationResult,
      required: true,
    },
  },
  emits: ['carouselCartClick'],
  setup(props, { emit }) {
    const { trackCitationClick } = usePDPAnalytics()
    const route = useRoute()
    const url = route.value.path.toString()
    const citationLineEmits = () => {
      emit(
        'carouselCartClick',
        0, // current starting image for carousel
        props.citationResult.images.map((image) => ({
          ...image,
          author_list: props.citationResult.author_list,
          title: props.citationResult.title,
          pubmedid: props.citationResult.pubmedid,
          published_date: props.citationResult.published_year,
        }))
      )
    }

    return { citationLineEmits, generateReferenceUrl, trackCitationClick, url }
  },
})
